import { useMutation, useQueryClient } from "@tanstack/react-query";
import { authApi } from "./api";
import { qk } from "../../lib/queryKeys";

export const useLogin = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: authApi.login,
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: qk.me() });
    },
  });
};

export const useChangePassword = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: authApi.changePassword,
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: qk.me() });
    },
  });
};

export const useLogout = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: authApi.logout,
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: qk.me() });
    },
  });
};

export const useForgotPassword = () => {
  return useMutation({
    mutationFn: authApi.forgotPassword,
  });
};

export const useConfirmForgotPassword = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: authApi.confirmForgotPassword,
    onSuccess: () => qc.invalidateQueries({ queryKey: qk.me() }),
  });
};
